import {
    getDoc, doc, getDocs, collection, query, where, orderBy, limit, startAfter, documentId,
} from 'firebase/firestore'
import { db } from '../system/firebase/index'
import { getAlgoliaCollections } from './Algolia'

export const getCollectionListBySearch = async ({ page = 0, perPage = 25, term = false, category = false, whereArray = false }) => {
    // get Algolia COLLECTION index raw search results / hits
    const algoliaResponse = await getAlgoliaCollections({ page, perPage, term, category, whereArray, visibleOnly: true })

    // use the Algolia hits to get full web profiles
    // NOTE: we send individual firestore requests because there is no current way to get multiple documents by id - batching only allows 10 at a time (and same number of reads) and doesn't preserve ordering - firestore is also optimised for multiple reads
    const webProfilesRequests = algoliaResponse.hits.map((hit) => getDoc(doc(db, 'collectionWebProfiles', hit.objectID)).then((result) => ({ ...result.data(), id: result.id })))
    const webProfiles = await Promise.all(webProfilesRequests)

    return { list: webProfiles, page: algoliaResponse.page, nbPages: algoliaResponse.nbPages }
}

export const getCollectionList = async ({
    category = [], by = 'date_published', direction = 'desc', lastVisible = false, page = 0, limitNumber = 25, whereArray = [],
}) => {
    // Set parameters to search sale profiles for relevant category
    const constraints = [where('active', '==', true), where('visibility', '==', 'public')]
    const profileList = []
    const collectionResult = { list: [], lastVisible, filter: []}

    if (category.length) {
        constraints.push(where('categories', 'array-contains-any', category))
    }
    if (whereArray.length) {
        constraints.push(where(whereArray[0], whereArray[1], whereArray[2]))
    }
    constraints.push(orderBy('date_modified', 'desc'))

    if (page && collectionResult.lastVisible) {
        const docCollectionRef = doc(db, 'collectionSearch', collectionResult.lastVisible)
        const docCollectionSnap = await getDoc(docCollectionRef)
        if (docCollectionSnap.exists) {
            constraints.push(startAfter(docCollectionSnap))
        }
    }
    if (limitNumber > 0) {
        constraints.push(limit(limitNumber))
    }

    // Search sale profiles and return relevant docs
    const q = query(collection(db, 'collectionSearch'), ...constraints)
    const qSnapshot = await getDocs(q)
    qSnapshot.forEach((doc) => {
        const item = { ...doc.data() }
        item.id = doc.id
        collectionResult.list.push(item)
        collectionResult.lastVisible = item.id
    })

    return collectionResult
}
